import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { cosmosBaseCard } from '@costar/theme-ui';

var card = cosmosBaseCard.card;
var header = cosmosBaseCard.header;
var title = cosmosBaseCard.title;
var footer = cosmosBaseCard.footer;
var cosmosV1 = {
  card: _objectSpread2(_objectSpread2({}, card), {}, {
    minWidth: '340px',
    border: 'neutral.light'
  }),
  header: _objectSpread2(_objectSpread2({}, header), {}, {
    p: 'lg'
  }),
  title: _objectSpread2({}, title),
  content: {
    variant: undefined,
    fontSize: undefined
  },
  footer: _objectSpread2({}, footer)
};
var cards = _objectSpread2(_objectSpread2({}, cosmosV1), {}, {
  'cosmos-v2': _objectSpread2(_objectSpread2({}, cosmosV1), {}, {
    title: _objectSpread2(_objectSpread2({}, cosmosV1.title), {}, {
      fontSize: 'md',
      fontWeight: 'bold'
    })
  })
});

export { cards };
//# sourceMappingURL=cards.esm.js.map
